var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOprAlertIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 34,
    viewBox: "0 0 33 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.5672 16.9998C31.5672 25.3945 24.7619 32.1998 16.3672 32.1998C7.97245 32.1998 1.16718 25.3945 1.16718 16.9998C1.16718 8.60507 7.97245 1.7998 16.3672 1.7998C24.7619 1.7998 31.5672 8.60507 31.5672 16.9998Z",
    fill: "#E8D420"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.3672 16.9998V9.3998M16.3672 22.633V22.6998M31.5672 16.9998C31.5672 25.3945 24.7619 32.1998 16.3672 32.1998C7.97245 32.1998 1.16718 25.3945 1.16718 16.9998C1.16718 8.60507 7.97245 1.7998 16.3672 1.7998C24.7619 1.7998 31.5672 8.60507 31.5672 16.9998Z",
    stroke: "#060607",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOprAlertIcon);
export default __webpack_public_path__ + "static/media/oprAlertIcon.8cd2cb3c2c7e8761064c0e0129bd845a.svg";
export { ForwardRef as ReactComponent };